export default "__VITE_ASSET__CdEDuDdL__"